import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface IconProps {
  color?: string;
}

export const Icon = styled(FontAwesomeIcon)<IconProps>`
  color: ${(props) => props.color || props.theme.primaryColor};
  &:hover {
    cursor: pointer;
  }
`;
